export const scheduledEvents = [
    /**
     * **قناةٌ قربت تُطوى** — وينبّه أعضاءَها قبلها بيوم.
     *
     * **ويقف بالطيّ أو بأوّل رسالة**: فالوسمُ محفوظٌ في الصفّ، فلا يتكرّر
     * التنبيهُ كلَّ دورة. وجمهورُه **أعضاؤها** لا قدرةٌ: فطيُّ قناةٍ خبرٌ عن
     * محادثةٍ بعينها، لا نداءٌ لمن يستطيع التصرّف.
     */
    {
        event: "chat.foldSoon",
        subject: "channel",
        audience: { kind: "record-participants" },
        severity: "normal",
        firedBy: "apps/api/src/chat/relay.ts",
        cadence: { every: "يومياً", stopsAfter: "الطيِّ أو أوّلِ رسالةٍ تُحييها" },
    },
    /**
     * **تذكيرا الاجتماع — قبل ساعةٍ وقبل خمس دقائق** (§هـ، وكان صحيحاً في v2).
     *
     * **وجمهورُهما أهلُ الصفّ** — طرفا الاجتماع: فالتذكيرُ خبرٌ عن موعدٍ بعينه،
     * لا نداءٌ لمن يستطيع التصرّف. ويصل العميلَ كما يصل مديرَ حسابه.
     *
     * **ويقفان بتغيُّر الموعد أو بإلغائه** — والمنعُ بنيويّ لا بعمود: سببُ الحدث
     * يحمل **موعدَ الاجتماع نفسَه**، فاجتماعٌ أُعيد جدولتُه يُنتج سبباً جديداً
     * (فيُنبَّه على موعده الجديد)، **والمُلغى يخرج من شرط المُولِّد فلا يُكتَب له
     * شيءٌ أصلاً**. وأمسكتُ هذا الدرسَ في مُولِّد الطيّ: سببٌ لا يحمل نوبتَه
     * **ينبّه مرّةً واحدةً في عمر النظام**.
     */
    {
        event: "meeting.reminderHour",
        subject: "meeting",
        audience: { kind: "record-participants" },
        severity: "normal",
        firedBy: "apps/api/src/meetings/relay.ts",
        cadence: { every: "كل خمس دقائق", stopsAfter: "مرورِ الموعد أو تغيُّره أو إلغائه" },
    },
    {
        event: "meeting.reminderSoon",
        subject: "meeting",
        audience: { kind: "record-participants" },
        severity: "high",
        firedBy: "apps/api/src/meetings/relay.ts",
        cadence: { every: "كل خمس دقائق", stopsAfter: "مرورِ الموعد أو تغيُّره أو إلغائه" },
    },
    /**
     * **بلوغُ هدفٍ وكسرُه** — وعلى الانتقال وحده (قرار شادي ٢٠٢٦-١٠-١٥).
     *
     * وجمهورُه **من يحدّد الأهداف**: فهو من يتصرّف على كسرِها. ولا يُجمهَر على
     * «من يرى اللوحة» — **فقدرةُ قراءةٍ ليست نداءً للتصرّف**، وهي قاعدةٌ تفرضها
     * البوّابةُ هنا بأن تطلب قدرةَ تصرّف.
     *
     * **ويقف بانتهاء الشهر**: هدفٌ مُقاسٌ على شهرٍ مضى لا يُعاد قياسُه — حالتُه
     * المُبلَغةُ محفوظة، فلا يتكرّر إشعارُه ولو دار المُولِّدُ ألفَ مرّة.
     */
    {
        event: "analytics.goalAchieved",
        subject: "company_goal",
        audience: { kind: "capability-holders", capability: "analytics.goals.manage" },
        severity: "normal",
        firedBy: "apps/api/src/analytics/relay.ts",
        cadence: { every: "يومياً", stopsAfter: "أوّلِ بلوغٍ للهدف" },
    },
    {
        event: "analytics.goalBreached",
        subject: "company_goal",
        audience: { kind: "capability-holders", capability: "analytics.goals.manage" },
        severity: "high",
        firedBy: "apps/api/src/analytics/relay.ts",
        cadence: { every: "يومياً", stopsAfter: "انتهاءِ شهر الهدف" },
    },
    /**
     * تذكيرُ الموعد — قبله بالساعات التي يضبطها المشتري (`work.dueReminderHours`).
     *
     * وجمهورُه **أهلُ الكارت**: منشئُه ومسنَدوه. ولا يُجمهَر على قدرة، فهو خبرٌ عن
     * شغلٍ بعينه لا نداءٌ لمن يستطيع التصرّف.
     */
    {
        event: "cards.reminder.due",
        subject: "card",
        audience: { kind: "record-participants" },
        severity: "normal",
        firedBy: "apps/api/src/cards/relay.ts",
        cadence: { every: "work.dueReminderHours", stopsAfter: "الموعد نفسه" },
    },
    /**
     * تصعيدُ التأخير — **بعد يومين، ثم يومياً** (قرار شادي ٢٠٢٦-٠٩-٢٦).
     *
     * وفي v2 كان **مرّةً واحدةً عند الموعد ثم يصمت**، وجمهورُه «رؤساءُ أقسام
     * **قالب** البورد» — والبورد بلا قالبٍ لا يسهم بقسمٍ واحد، و٣٩ من آخر ٤٠ بورد
     * بلا قالب. فنصفُ الجمهور **لا يصل إلى أحد** على البورد العادي.
     */
    /**
     * **التذكيرُ اليوميُّ بعد الموعد** — لأهل الكارت، بعدد أيام التأخير، ما دام
     * المشتري فتحه (`work.overdueDailyReminder`).
     */
    {
        event: "cards.reminder.overdue",
        subject: "card",
        audience: { kind: "record-participants" },
        severity: "normal",
        firedBy: "apps/api/src/cards/relay.ts",
        cadence: { every: "يوم", stopsAfter: "إنجاز البطاقة أو أرشفتها" },
    },
    {
        event: "cards.escalation.late",
        subject: "card",
        audience: { kind: "capability-holders", capability: "cards.escalations.receive" },
        severity: "high",
        firedBy: "apps/api/src/cards/relay.ts",
        cadence: { every: "يوم", stopsAfter: "إنجاز البطاقة أو أرشفتها" },
    },
    /**
     * **السلسلةُ المتعثّرة — مرّةً كلَّ ثلاثة أيام** (قرار شادي ٢٠٢٦-١٠-٢٧).
     *
     * مهمةٌ يوميةٌ لا يقفلها صاحبُها مشكلةٌ تُرفَع لرئيس قسمه وللإدارة — «بس مش كل يوم».
     * **ونسخُها القديمةُ لا تُصعَّد واحدةً واحدة**: كانت ١٥٩ تصعيداً في يومٍ لعميلٍ واحد.
     */
    {
        event: "cards.recurrence.stalled",
        subject: "card",
        audience: { kind: "capability-holders", capability: "cards.escalations.receive" },
        severity: "high",
        firedBy: "apps/api/src/cards/relay.ts",
        cadence: { every: "ثلاثة أيام", stopsAfter: "إنجاز النسخ المتأخّرة أو أرشفتها" },
    },
    /**
     * عتبةُ التخزين — **مرّةً لكل عتبة**، لا كل نشرة.
     *
     * والحالةُ في القاعدة (`quotaNoticeAt`) لا في ذاكرة العملية: في v2 كانت أربعُ
     * مهمّاتٍ تحفظ حالة منع التكرار في الذاكرة، **فكل نشرةٍ تُعيد التنبيه من الصفر**.
     */
    {
        event: "clients.quota.threshold",
        subject: "client",
        audience: { kind: "capability-holders", capability: "clients.storage.manage" },
        severity: "high",
        firedBy: "apps/api/src/clients/quota.ts",
        cadence: { every: "عتبة", stopsAfter: "رفع الحدّ أو تفريغ المساحة" },
    },
    /**
     * تنبيهُ العميل المؤرشف — **أربع مرّاتٍ أسبوعياً ثم يصمت**.
     *
     * ولم تحدّد وثيقةٌ في v2 متى يتوقّف: «يتكرّر أبداً حتى يُكتَم أو يُحذَف العميل».
     * وفي الوقت نفسه كان بندُ إجرائه **لا يُغلَق أبداً** فصار التنبيهُ الأسبوعي
     * **مرّةً واحدة**. عطبان متضادّان في ميزةٍ واحدة، وعدّادٌ في القاعدة يُغلقهما.
     */
    {
        event: "clients.archive.reminder",
        subject: "client",
        audience: { kind: "capability-holders", capability: "clients.delete" },
        severity: "normal",
        firedBy: "apps/api/src/clients/service.ts",
        cadence: { every: "أسبوع", stopsAfter: "أربع مرّات، أو كتمُه، أو استعادةُ العميل" },
    },
    /**
     * كارتٌ وُلد من قاعدة تكرار — **ويُخبَر مسنَدوه**.
     *
     * وكان المُولِّد يضع الكارت على البورد **بلا كلمة**: يستيقظ صاحبُه ليجد شغلاً
     * بموعدٍ لم يُخبره به أحد. ولم تكن ثغرةً في الإعلان بل **في غياب المُولِّد
     * أصلاً** — فما لا يعمل لا يُسأل عمّن يُبلِّغه.
     */
    {
        event: "cards.recurrence.spawned",
        subject: "card",
        audience: { kind: "record-participants" },
        severity: "normal",
        firedBy: "apps/api/src/cards/recurrence-relay.ts",
        cadence: { every: "دورةُ القاعدة", stopsAfter: "إيقافُ القاعدة أو أرشفةُ البطاقة" },
    },
    /**
     * نسخةُ العميل جاهزة — **وجمهورُها من طلبها**.
     *
     * ولا تُجمهَر على قدرة: النسخةُ تُطلَب لسببٍ يعرفه طالبُها، وغالباً ليحذف
     * بعدها. فمن طلب هو من ينتظر.
     */
    {
        event: "clients.export.ready",
        subject: "client",
        audience: { kind: "actor" },
        severity: "normal",
        firedBy: "apps/api/src/clients/export.ts",
        cadence: { every: "طلبٌ واحد", stopsAfter: "مرّةً واحدة لكل طلب" },
    },
    /**
     * **ونسخةٌ فشلت تُقال بصوتٍ أعلى** — فالحذف محجوبٌ عليها.
     *
     * ولو صمتت، انتظر طالبُها نسخةً لا تأتي **وبقي العميل غيرَ قابلٍ للحذف بلا
     * سبب يُقرأ**. وهو بعينه المطلب المركزي: لا فشلَ بلا رسالةٍ وكودٍ يُقتبَس.
     */
    {
        event: "clients.export.failed",
        subject: "client",
        audience: { kind: "actor" },
        severity: "high",
        firedBy: "apps/api/src/clients/export.ts",
        cadence: { every: "طلبٌ واحد", stopsAfter: "مرّةً واحدة لكل طلب" },
    },
    /**
     * يتيمٌ وُجد — **مرّةً واحدة لكل يتيم، لا كل ساعة**.
     *
     * وكانت المصالحة تكتبهم في جدولٍ **لا يقرؤه أحد**: لا مسار، ولا شاشة، ولا
     * إشعار. وهو بعينه ما بُنيت لإغلاقه — «١١ من ١٣ كائناً يتيماً، بلا شاشةٍ
     * تعرضها». فأعدتُ العطب طبقةً أعلى: الجدول موجود، والقارئ غائب.
     *
     * ومعرّفُ الربط **معرّفُ صفّ اليتيم**، فيُعلَن مرّةً ولا يُنبِّه كل ساعة.
     */
    /**
     * **نسخٌ سقط** — وآخرُ نسخةٍ تكبر في العمر حتى يُصلَح، فيُبلَّغ من يقرأ صحة النظام.
     */
    {
        event: "platform.backup.failed",
        subject: "backup_run",
        audience: { kind: "capability-holders", capability: "platform.incidents.resolve" },
        severity: "high",
        firedBy: "apps/api/src/platform/backup.ts",
        cadence: { every: "ساعة", stopsAfter: "مرّةً في اليوم ما دام يسقط — ثم يتوقّف بأوّل نجاح" },
    },
    {
        event: "storage.orphan.found",
        subject: "orphan_object",
        audience: { kind: "capability-holders", capability: "clients.storage.manage" },
        severity: "high",
        firedBy: "apps/api/src/storage/reconcile.ts",
        cadence: {
            every: "ساعة",
            stopsAfter: "مرّةً لكل عميلٍ في الدورة، بعدد ما وُجد له، ولا يُعاد عن يتيم — ثم استردادُه أو عودتُه سليماً",
        },
    },
    /**
     * استثناءُ مراجعةٍ لم يبتّ فيه أحد — **والعنصر واقفٌ ما دام معلّقاً**.
     *
     * فصمتُ الإدارة يوقف شغلاً حقيقياً: لا يمضي ولا يُنشَر ولا يُرفَض. ومدّتُه
     * إعدادٌ يملكه المشتري، **وأمسكت بوابةُ «المُعلَن مقروءاً له قارئ» أنه كان
     * بلا قارئ** — فنزل المُولِّد.
     */
    {
        event: "plans.exception.escalated",
        subject: "plan_item",
        audience: {
            kind: "capability-holders",
            capability: "plans.revision_exceptions.resolve",
        },
        severity: "critical",
        firedBy: "apps/api/src/plans/escalation.ts",
        cadence: {
            every: "plans.revisionExceptionEscalationHours",
            stopsAfter: "مرّةً واحدة لكل استثناء — ثم البتّ فيه",
        },
    },
];
export const SCHEDULED_EVENTS = scheduledEvents.map((e) => e.event);
export function scheduledEvent(event) {
    return scheduledEvents.find((e) => e.event === event);
}
/** كياناتُ الأحداث المجدولة — **مشتقّةٌ لا مكتوبة**، فلا تتخلّف عن السجلّ */
export function scheduledSubjects() {
    return [...new Set(scheduledEvents.map((e) => e.subject))];
}
/** قدراتُ الجمهور المُعلَنة هنا — يفحصها اختبارٌ أنها قدراتُ تصرّف */
export function scheduledAudienceCapabilities() {
    return scheduledEvents.flatMap((e) => e.audience.kind === "capability-holders" ? [e.audience.capability] : []);
}
//# sourceMappingURL=scheduled.js.map